import React from "react";
import { Layout, Drawer, Row, Col, 
    // message 
} from "antd";
import PropTypes from "prop-types";
import { connect } from "react-redux";
// import { bindActionCreators } from "redux";
import AddDocumentChecklistForm from "forms/add-document-checklist-form";

class DocumentChecklistCreator extends React.Component{
    state = {
        isDocumentCreateDrawerVisible: false
    };

    componentDidMount() {
        this.setState({
            isDocumentCreateDrawerVisible: true
        });
        // if(this.props.businessProgramId) {
        //     this.props.fetchBusinessProgramDetail(this.props.businessProgramId);
        // }
    }

    render() {
        return (
            <Col span={24}>
                <Drawer
                    visible={this.state.isDocumentCreateDrawerVisible}
                    closable={true}
                    mask={true}
                    maskClosable={true}
                    placement={"bottom"}
                    height={"100vh"}
                    onClose={() => {
                        this.setState(
                            {
                                isDocumentCreateDrawerVisible: false
                            },
                            () => {
                                this.props.history.replace("/app/checklist");
                            }
                        );
                    }}
                >
                    <Layout
                        style={{height: "100vh", overflow: "scroll"}}
                    >
                        <Row>
                            <Col>
                                <AddDocumentChecklistForm />
                            </Col>
                        </Row>
                    </Layout>
                </Drawer>
            </Col>
        );
    }
}

DocumentChecklistCreator.propTypes = {
    history: PropTypes.object
};

export default connect(null, null) (DocumentChecklistCreator);